// extracted by mini-css-extract-plugin
export default {"body":"Packages_body__gT8zJ","sectionWrapper":"Packages_sectionWrapper__FBQ84"};